import React from 'react';

import '../../scss/components/loader.scss';

const Loader = ({ label, size }) => (
  <div className="presse__loader-wrapper">
    <img
      className="next-loader"
      src={ `${window.appConfig.basePath}/wp-content/themes/ArtePresse/assets/vectors/loader.svg` }
      width={ size || 40 }
      height={ size || 40 }
      alt={ label || 'loading...' }
    />
  </div>
);

export default Loader;
